import wrapComponent from '../../tools/wrapComponent';
var TableCell = wrapComponent({
  name: 'TableCell',
  type: 'td'
});
export default TableCell;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/DataTable/TableCell.js
// module id = 583
// module chunks = 0